export const _SIGNOUT = (host: string): string | null => {
  if (host?.includes("trichy")) {
    const clientId = "30rttfvapq6sg98j5fjcq9t3ll";
    const logoutUri =
      "https://staff.trichy.dev.aavinsales.com";
    const cognitoDomain =
      "https://ap-south-1hfhsw9sfw.auth.ap-south-1.amazoncognito.com";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else if (host?.includes("vellore")) {
    const clientId = "7mdfchangg1fjgmki82k3v82vb";
    const logoutUri = "https://staff.vellore.dev.aavinsales.com";
    const cognitoDomain =
      "https://ap-south-18mscy630p.auth.ap-south-1.amazoncognito.com";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else if (host?.includes("thanjavur")) {
    const clientId = "5vlnunugkc870vqv6mnbisttf4";
    const logoutUri = "https://staff.thanjavur.dev.aavinsales.com";
    const cognitoDomain =
      "https://ap-south-18mscy630p.auth.ap-south-1.amazoncognito.com";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else if (host?.includes("kallakurichi")) {
    const clientId = "2ncddvlc8re0u4bsetplikodue";
    const logoutUri = "https://staff.kallakurichi.dev.aavinsales.com";
    const cognitoDomain =
      "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_yn49n3Zaa";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else if (host?.includes("pudukkottai")) {
    const clientId = "6p342j8c3lkgavih8uilrv2b1p";
    const logoutUri = "hhttps://staff.pudukkottai.dev.aavinsales.com";
    const cognitoDomain =
      "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_kIXj61yz0";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else if (host?.includes("dindigul")) {
    const clientId = "3vrl6fvo3gcnsu88stoqgpds9g";
    const logoutUri = "https://staff.dindigul.dev.aavinsales.com";
    const cognitoDomain =
      "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_hLu4DaST2";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else if (host?.includes("villupuram")) {
    const clientId = "6di0vmefrodjgh736bhqv7n8c2";
    const logoutUri = "https://staff.villupuram.dev.aavinsales.com";
    const cognitoDomain =
      "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_i5YFQvlbb";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else if (host?.includes("ktunion")) {
    const clientId = "5b59tn8i6akmrld625cbvh1gq4";
    const logoutUri = "https://staff.ktunion.dev.aavinsales.com";
    const cognitoDomain =
      "https://ap-south-1dz2ljhqdv.auth.ap-south-1.amazoncognito.com";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  } else {
    //dev
    const clientId = "4741ohv03oceamafslppvvag7u";
    const logoutUri = "http://localhost:3000";
    const cognitoDomain =
      "https://ap-south-1uhdvcj9ky.auth.ap-south-1.amazoncognito.com";
    return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  }
};
